import fetchAPI from '../../../../lib/utils/fetch-api'

export async function getModulesList() {
  return fetchAPI('/api/settings/modules')
}

export async function getModulePreview(code: string, mode: 'now' | 'next_period') {
  return fetchAPI(`/api/settings/modules/preview?code=${encodeURIComponent(code)}&mode=${mode}`)
}

export async function activateModule(code: string, mode: 'now' | 'next_period') {
  return fetchAPI(`/api/settings/modules/${encodeURIComponent(code)}/activate`, {
    method: 'POST',
    body: JSON.stringify({ mode }),
  })
}

export async function deactivateModule(code: string, mode: 'now' | 'next_period' = 'now') {
  return fetchAPI(`/api/settings/modules/${encodeURIComponent(code)}/deactivate`, {
    method: 'POST',
    body: JSON.stringify({ mode }),
  })
}

export async function setBillingTerm(termMonths: number, mode: 'now' | 'next_period') {
  return fetchAPI('/api/settings/modules/term', {
    method: 'POST',
    body: JSON.stringify({ term_months: termMonths, mode }),
  })
}

export async function getBillingPayments() {
  return fetchAPI('/api/billing/payments')
}

export async function createBillingPayment(
  payload: { period_start?: string; comment?: string } = {},
) {
  return fetchAPI('/api/billing/payments', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
